var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('section',{staticClass:"pdf-item"},_vm._l((_vm.feed),function(item){return _c('feed-item',{key:item.id,attrs:{"feed-data":item,"forExport":_vm.forExport}})}))])}
var staticRenderFns = []

export { render, staticRenderFns }